"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGoogleMapsToken = exports.GoogleMapsConfig = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var GoogleMaps_1 = __importDefault(require("@CommonFrontend/Public/Widgets/GoogleMaps"));
var lodash_1 = require("lodash");
var MediaVariable_1 = require("@CommonFrontend/ContentTokens/Models/MediaVariable");
var Common_1 = require("@CommonFrontend/ContentTokens/Models/Common");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var IsResizeableWidget_1 = require("../Utils/IsResizeableWidget");
exports.GoogleMapsConfig = {
    publicRenderHtmlString: function (_a) {
        var attributes = _a.attributes, token = _a.token, isPrintMode = _a.isPrintMode;
        if (!(0, IsResizeableWidget_1.isResizeableWidget)(token)) {
            throw new Error("Google maps widget is resizeable");
        }
        return server_1.default.renderToString(react_1.default.createElement(GoogleMaps_1.default, { embedUrl: token.embedUrl, width: token.width, attributes: attributes, isPrintMode: isPrintMode }));
    },
    type: "googleMaps",
    tokenType: {},
    traits: {
        resizeable: { handleDirections: "corners", width: { custom: true, wide: true, minInPx: 280, default: 100 } },
        mediaVariable: {
            toMediaVariableToken: function (token) {
                var nextToken = __assign(__assign(__assign({}, (0, lodash_1.cloneDeep)(token)), { media: MediaVariable_1.Media.GoogleMaps, subType: Common_1.BlockType.MediaVariable, label: token.variable.label, name: token.variable.name }), (0, CommonUtils_1.includeIf)(!!token.variable.substitutionToken, {
                    substitutionToken: token.variable.substitutionToken,
                }));
                delete nextToken["displayUrl"];
                delete nextToken["embedUrl"];
                delete nextToken["variable"];
                return nextToken;
            },
        },
        spacingShim: {
            className: "google-maps-widget__spacing-shim",
        },
    },
};
var createGoogleMapsToken = function (options) {
    return __assign({ type: "block", subType: "googleMaps" }, options);
};
exports.createGoogleMapsToken = createGoogleMapsToken;
